<template>
  <div class="home">
    <Header />
    <Hall v-if="!session.NoSeats" />
    <SelectPlaceWithoutHall v-else />
    <Footer />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Hall from './Hall/Hall.vue';
import SelectPlaceWithoutHall from './SelectPlaceWithoutHall/SelectPlaceWithoutHall.vue';
import Header from '../../components/layouts/Header/Header';
import Footer from '../../components/layouts/Footer/Footer';

export default {
  name: 'home',
  components: {
    Hall,
    SelectPlaceWithoutHall,
    Header,
    Footer,
  },
  computed: {
    ...mapState(['session']),
  },
  mounted() {
    this.$store.dispatch('loadHall', {
      theatreId: this.$route.params.theatreId,
      session: this.$route.params.session,
      filmId: this.$route.query.filmId,
    });
  },
};
</script>

<style lang="scss">
.home {
  height: 100vh;
}
</style>
